import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    this.scheduleNextPoll()
  }

  disconnect() {
    this.cancelNextPoll()
  }

  scheduleNextPoll() {
    this.timeoutId = setTimeout(() => this.poll(), this.intervalValue)
  }

  cancelNextPoll() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  async poll() {
    try {
      const url = `${this.urlValue}${this.urlValue.includes("?") ? "&" : "?"}_=${Date.now()}`
      const response = await fetch(url, {
        cache: "no-store",
        headers: {
          "Accept": "text/html",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        }
      })

      if (response.ok) {
        const html = await response.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const newFrame = doc.getElementById("analysis_status")
        const currentFrame = document.getElementById("analysis_status")

        if (newFrame && currentFrame) {
          currentFrame.replaceWith(newFrame)
        }
      }
    } catch (error) {
      console.error("Analysis polling error:", error)
    }

    // Continue polling only if this element is still connected (i.e., still analyzing)
    if (this.element.isConnected) {
      this.scheduleNextPoll()
    }
  }
}
